import { render, staticRenderFns } from "./PropertyOverviewCard.vue?vue&type=template&id=4a466e2a&scoped=true&"
import script from "./PropertyOverviewCard.vue?vue&type=script&lang=js&"
export * from "./PropertyOverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./PropertyOverviewCard.vue?vue&type=style&index=0&id=4a466e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a466e2a",
  null
  
)

export default component.exports